import type { MailboxInfo } from "owa-client-types";
import type TableView from "../../store/schema/TableView";
import { groupRowKeysByMailboxInfo } from "./groupRowKeysByMailboxInfo";

/**
 * Returns true when the current selection resolves to exactly one mailbox.
 * @param defaultMailboxInfo the table's mailbox info (the synthetic UnifiedInbox mailbox in UIB)
 * @param tableView the table view holding the current selection
 */
export function isSelectionWithinSingleMailbox(defaultMailboxInfo: MailboxInfo, tableView: TableView): boolean {
    if (tableView.isInVirtualSelectAllMode) {
        return false;
    }
    
    const rowKeys = [...tableView.selectedRowKeys.keys()];
    if (rowKeys.length === 0) {
        return false;
    }
    
    try {
        return groupRowKeysByMailboxInfo(defaultMailboxInfo, rowKeys, tableView).size === 1;
    }
    catch {
        // If any selected row cannot be resolved to a mailbox, treat it as not a single mailbox.
        return false;
    }
}
